import React, { useState } from 'react'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import Tooltip from '../Tooltip'
import Highlight, { defaultProps } from 'prism-react-renderer'
import { theme } from './theme'
import copyIcon from '../../assets/svg/copy.svg'

const StyledPre = styled.code`
  cursor: text;
  display: flex;
  font-size: 0.625em;
  margin: 0;
  overflow: hidden;
  position: relative;
  text-align: left;
  white-space: pre-wrap;

  & .token-line {
    line-height: 1.4em;
    min-height: 1.3em;
    position: relative;
    z-index: 200;
    
    &:hover {
      background-color: #05254a;

      > span {
        color: #fff;
      }
    }
  }

  ${({ theme }) => theme.media.desktop} {
    font-size: 0.75em;
    margin: 0;
    overflow: hidden;
  }
`
const StyledBackground = styled.div`
  background-color: #11243e;
  border-bottom-left-radius: 8px;
  height: auto;
  width: 50px;

  ${({ theme }) => theme.media.desktop} {
    width: 31px;
  }
`

const StyledLineNo = styled.span`
  color: rgba(255, 255, 255, 0.2);
  cursor: default;
  display: inline-block;
  margin-right: -16px;
  padding-right: 12px;
  text-align: right;
  transform: translateX(-25px);
  user-select: none;
  width: 31px;

  ${({ theme }) => theme.media.desktop} {
    transform: translateX(-28px);
  }
`
const StyledCopy = styled.div`
  bottom: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 16px;
  z-index: 2000;

  ${({ theme }) => theme.media.desktop} {
    bottom: initial;
    top: 16px;
  }
`
const StyledCodeSnippet = styled.div`
  border-radius: 8px;
  box-shadow: 0 1px 1px 0 rgba(10, 22, 70, 0.1),
  0 0 1px 0 rgba(10, 22, 70, 0.06), 0 28px 70px -4px rgba(5, 15, 54, 0.08);
  margin-bottom: 48px;
  margin-top: 48px;
  overflow: hidden;
  position: relative;
  width: 100%;
`
const StyledCode = styled.span`
  padding: 0.5em;
  padding-top: 16px;
`
const PostBlogEmeddableCodeSnippet = ({ cmsData }) => {
  const [tooltip, setTooltip] = useState(null)

  const _onCopy = snippet => {
    const _tempTextarea = document.createElement('textarea')
    _tempTextarea.innerHTML = snippet['en-US']
    document.body.appendChild(_tempTextarea)
    _tempTextarea.select()
    document.execCommand('copy')
    document.body.removeChild(_tempTextarea)
    setTooltip(true)
    setTimeout(() => {
      setTooltip(false)
    }, 2000)
  }

  return (
    <StyledCodeSnippet>
      <Highlight
        {...defaultProps}
        theme={theme}
        code={cmsData.code['en-US']}
        language={cmsData.lang['en-US']}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <StyledPre className={className} style={style}>
            <StyledBackground />
            <StyledCode>
              {tokens.map((line, i) => (
                <div {...getLineProps({ line, key: i })}>
                  <StyledLineNo>{i + 1}</StyledLineNo>
                  <span>
                    {line.map((token, key) => (
                      <span {...getTokenProps({ token, key })} />
                    ))}
                  </span>
                </div>
              ))}
            </StyledCode>
          </StyledPre>
        )}
      </Highlight>
      <StyledCopy onClick={() => _onCopy(cmsData.code)}>
        <SVG src={copyIcon} />
        {tooltip === true ? <Tooltip message="Copied!" /> : null}
      </StyledCopy>
    </StyledCodeSnippet>
  )
}

export default PostBlogEmeddableCodeSnippet
